import React from 'react';
import { Col, Row } from 'antd';
import { LANDING_FEATURE_CARDS } from '../content/landingContent';
import FeatureIcon from './FeatureIcon';

const FeatureGrid: React.FC = () => (
  <Row gutter={[24, 24]} className="cp-landing-feature-grid">
    {LANDING_FEATURE_CARDS.map((feature) => (
      <Col key={feature.id} xs={24} sm={12} lg={8}>
        <article className="cp-landing-feature-card">
          <span className="cp-landing-feature-card__icon-wrap">
            <FeatureIcon iconKey={feature.iconKey} className="cp-landing-feature-card__icon" />
          </span>
          <h3 className="cp-landing-feature-card__title">{feature.title}</h3>
          <p className="cp-landing-feature-card__text">{feature.description}</p>
        </article>
      </Col>
    ))}
  </Row>
);

export default FeatureGrid;
